/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import { useDispatch, useSelector } from "react-redux";
import {
  IsPermisionOidRequired,
} from "../../../redux/actions";
import { responseApproval, responseMiddleware } from "../../../redux/reducers";
import ApprovalSettingDepartmentTable from "./ApprovalSettingEmployeeTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import { axios } from "../../../common";

export default function ApprovalSettingDepartmentList() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const dataGridRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [levelColumns, setLevelColumns] = useState([]);

  // get data from redux
  const { approvalSettingEmployee } = useSelector(responseApproval);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    UsingIntl();
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (!ReadState && ReadState !== undefined)
      ) {
        history.push("/403");
        return;
      }
      handleGetApprovalSettingEmployee();
    }
  }, [middleware]);

  const handleGetApprovalSettingEmployee = async () => {
    const { data } = await axios.get("PivotApprovalSetting(Employee)", {
      headers: {
        MappedState: 1,
      },
    });
    setDataSource(data.dataApproval);
    setLevelColumns(data.columns);

  };

  const handleSelectionChanged = ({ selectedRowKeys }) => {
    setSelectedRowKeys(selectedRowKeys);
  };
  const cellEditRender = ({ data }) => {
    return (
      <div>
        <Link to={`/approval/approval-setting-employee/${data.Oid}`}>
          <img
            src="/assets/images/icon-edit.svg"
            alt="edit-row"
            className="dx-icon-link-datagrid mr-2"
          />
        </Link>
        <img
          src="/assets/210107.png"
          alt="edit-row"
          width={20}
          height={20}
          className="dx-icon-link-datagrid"
          onClick={() => {
            handleDeleteRecord(data.Oid);
          }}
        />
      </div>
    );
  };

  const handleDeleteRecord = async (Oid) => {
    try {
      const { data } = await axios.post(
        `DeleteApprovalSettingEmployee(${Oid})`
      );

      handleGetApprovalSettingEmployee();

      notify("Delete success", "success", 3000);
      if (data) notify("Delete success", "success", 3000);
    } catch (error) {
      notify("Delete error", "erro", 3000);
    }
  };

  const handleDeleteRecords = () => {
    selectedRowKeys.forEach((key) => {
      handleDeleteRecord(key);
    });
    approvalSettingEmployee.reload();
  };

  const handleAction = (type) => {
    switch (type) {
      case "add":
        history.push("/approval/approval-setting-employee/create");
        break;
      case "edit":
        history.push(
          `/approval/approval-setting-employee/${selectedRowKeys[0]}`
        );
        break;
      case "delete":
        handleDeleteRecords();
        break;
      case "refresh":
        dataGridRef.current.instance.refresh();
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      <LoadPanel visible={isLoading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("ApprovalSettingEmployee")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/approval-setting/list" className={"breadcrumb-item"}>
            {formatMessage("Approval")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("ApprovalSettingEmployee")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <ApprovalSettingDepartmentTable
            dataTable={dataSource}
            dataGridRef={dataGridRef}
            middleware={middleware}
            handleAction={handleAction}
            selectedRowKeys={selectedRowKeys}
            onSelectionChanged={handleSelectionChanged}
            cellEditRender={cellEditRender}
            setIsLoading={setIsLoading}
            levelColumns={levelColumns}
          />
        </div>
      </div>
    </div>
  );
}
